import { Fragment, useEffect } from "react"
import { BaseTable, Card, CommandButton, Loading, RegisterLayout } from "../../../components"
import { Create, Item } from "./components"
import { DataProvider, useCoaGroup, useData, useFilter } from "./utils"
import { usePermission } from "utils"

interface SelectOptionType {
  label: string
  value: string
  permission?: string
}

export default function Register() {
  const { isLoading } = useCoaGroup()
  const dataTab = [
    { label: "Show All", value: "", permission: "AR01" },
    { label: "ASSETS", value: "1", permission: "AR02" },
    { label: "LIABILITY", value: "2", permission: "AR03" },
    { label: "EQUITY", value: "3", permission: "AR04" },
    { label: "INCOME", value: "4", permission: "AR05" },
    { label: "COST OF GOOD SOLD", value: "5", permission: "AR06" },
    { label: "EXPENSES", value: "6", permission: "AR07" },
    { label: "OTHER INCOME", value: "7", permission: "AR08" },
    { label: "OTHER EXPENSES", value: "8", permission: "AR09" }
  ]

  if (isLoading) {
    return (
      <section className="min-h-[500px]">
        <Loading loading />
      </section>
    )
  } else {
    return <ViewSection dataFilter={dataTab} />
  }
}

export function ViewSection(props: { dataFilter: SelectOptionType[] }) {
  const { value, setValue } = useFilter(props.dataFilter[0].value)
  const { data, isLoading, refetch } = useData()
  
  const permissionData = props?.dataFilter.find(element => element.value === value);
  const permission = usePermission([permissionData?.permission?.toString()!]);

  const items = data.filter(item => {
    const isParent: boolean = Boolean(item.parent_id === -1)

    if (value !== "") {
      return isParent && item.group_coa_id === value
    }

    return isParent
  })

  useEffect(() => {
    refetch()

    // eslint-disable-next-line
  }, [value])

  return (
    <Fragment>
      <section className="my-5 mx-5">
        {isLoading ? (
          <Loading loading />
        ) : (
          <DataProvider data={data} refetch={refetch}>
            <RegisterLayout.Header title="CHART OF ACCOUNTS REGISTER" />

            <RegisterLayout.Filter
              list={props.dataFilter}
              value={value}
              onChangeFilter={setValue}
            />

              <section className="mt-2">
                <Card>
                  <Card.Body className="flex-row justify-between items-center">
                    <Card.Title>CHART OF ACCOUNT</Card.Title>
                    {Boolean(value === "" || data.length === 0) && <Create onSuccess={refetch} />}
                  </Card.Body>

                  <Card.Body>
                    <div className="flex flex-col min-h-[calc(100vh-520px)]">
                      <BaseTable className="border-collapse">
                        <thead>
                          <tr>
                            <th>NO</th>
                            <th />
                            <th />
                            <th>CHQ</th>
                            <th>ACCOUNT</th>
                            <th>NAME</th>
                            <th>LINKED</th>
                            <th>LEVEL</th>
                            <th>ACC TYPE</th>
                            <th>BALANCE</th>
                            <th>ACTION</th>
                          </tr>
                        </thead>
                        
                        <tbody>
                          {items.length === 0 ? (
                            <tr>
                              <td colSpan={10} className="text-center">
                                <Loading errorText="No data available" />
                              </td>
                            </tr>
                          ) : items.map((item, key) => (
                            <Item permission={permission} key={key} index={key} item={item} onSuccess={refetch} />
                          ))}
                        </tbody>
                      </BaseTable>
                    </div>
                  </Card.Body>
                </Card>
              </section>

              <section className="mt-2">
                <Card>
                  <Card.Body className="flex flex-col gap-5">
                    <section className="flex flex-wrap justify-between items-center gap-3">
                      <section className="flex flex-wrap gap-3">
                        <CommandButton actiontype="help" />
                        <CommandButton actiontype="print" />
                        <CommandButton actiontype="email" />
                        <CommandButton actiontype="export" />
                      </section>
                    </section>
                  </Card.Body>
                </Card>
              </section>
          </DataProvider>
        )}
      </section>
    </Fragment>
  )
}